import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TranslationModule } from './translation-module';
import { FormBuilderDependencies, FormBuilderLibraryInjectionToken } from './interface';
import { FormSubmissionsExportService } from '@vendasta/forms_microservice';
import { FormSubmissionsExportCsvService } from '../lib/pages/form-submissions-export-csv.service';
import { FormFieldEditorService } from './components/form-editor/form-field-editor.service';
import { StylesService } from './components/preview-and-style/styles-service';
import { RxState } from '@rx-angular/state';
import { MappedFieldService } from './services/mapped-field.service';
import { UnmappedFieldService } from './services/unmapped-field.service';

const CUSTOM_FORMS_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/list/custom-forms-list.component').then((m) => m.CustomFormsListComponent),
  },
  {
    path: 'new',
    loadChildren: () => import('./pages/form/custom-forms-page.module').then((m) => m.CustomFormsPageModule),
  },
  {
    path: 'edit/:formId',
    loadChildren: () => import('./pages/form/custom-forms-page.module').then((m) => m.CustomFormsPageModule),
  },
  {
    path: 'submissions/:formId',
    loadComponent: () =>
      import('./pages/submissions/list-submissions.component').then((m) => m.FormsSubmissionListComponent),
  },
];

@NgModule({
  imports: [RouterModule.forChild(CUSTOM_FORMS_ROUTES), TranslationModule],
  exports: [RouterModule],
})
export class FormBuilderModule {
  static forRoot(config: InjectionToken<FormBuilderDependencies>): ModuleWithProviders<FormBuilderModule> {
    return {
      ngModule: FormBuilderModule,
      providers: [
        {
          provide: FormBuilderLibraryInjectionToken,
          useExisting: config,
          deps: [],
        },
        {
          provide: RxState, // useClass for each RxState<MySpecificData> ?
        },
        FormSubmissionsExportService,
        FormSubmissionsExportCsvService,
        FormFieldEditorService,
        StylesService,
        MappedFieldService,
        UnmappedFieldService,
      ],
    };
  }
}
